import apiClient from './client';

export interface PlanterInvitePreview {
  planterName: string;
  /** Normalized email from the invite (web uses this so planters do not retype it). */
  email: string;
  emailMasked: string;
  expiresAt: string;
}

export async function previewPlanterInvite(token: string): Promise<PlanterInvitePreview> {
  const { data } = await apiClient.get<{ success: boolean; data: PlanterInvitePreview }>(
    '/auth/planter-invite/preview',
    { params: { token } }
  );
  return data.data;
}

export interface AcceptPlanterInviteResponse {
  success: boolean;
  message?: string;
  user: {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    token?: string;
    refreshToken?: string;
    roles?: string[];
  };
}

export async function acceptPlanterInvite(payload: {
  token: string;
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
}): Promise<AcceptPlanterInviteResponse> {
  const { data } = await apiClient.post<AcceptPlanterInviteResponse>(
    '/auth/planter-invite/accept',
    payload
  );
  return data;
}

export async function linkExistingPlanterInvite(token: string): Promise<AcceptPlanterInviteResponse> {
  const { data } = await apiClient.post<AcceptPlanterInviteResponse>(
    '/auth/planter-invite/link-existing',
    { token }
  );
  return data;
}
